/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Link from "./Link";

const LinksContainer = ({ hidden }) => {
  return (
    <div css={styles} className={(hidden ? "hidden" : "") + " linksContainer"}>
      <Link name="HOME" linkTo="#home" />
      <Link name="HOSTEL TOUR" linkTo="#hostelTour" />
      <Link name="OUR FACILITIES" linkTo="#facility" />
      <Link name="REVIEWS" linkTo="#review" />
      <Link name="CONTACT" linkTo="#contact" />
      
    </div>
  );
};

const styles = css`
  width: 100%;
  max-width: 720px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1000px) {
    max-width: 100%;
    padding: 0 30px 20px 30px;
    flex-direction: column;
    align-items: flex-start;
    opacity: 1;
    position: absolute;
    left: 0;
    top: 70px;
    background: black;
    transition: top 1100ms ease-in-out, opacity 1100ms ease-in-out;
    &.hidden {
      left: 0;
      top: -500px;
      opacity: 0;
    }
    .btn {
      width: 100%;
      text-align: center;
      padding: 7px;
    }
  }
`;

export default LinksContainer;
